import { Search, UnorderedSearchIndex } from 'js-search'

export default class SearchService {

  constructor () {
    this.dataSources = []
    this.preSearchedDataSources = []
    this.originalDataSources = []
    this.filter = []
    this.initialized = false
  }

  addDataSource ({name, attributes}) {
    this.originalDataSources.push({
      name,
      attributes
    })
  }

  init () {
    this.filterDatasets()
    this.dataSources = this.preSearchedDataSources.map(dataSource => {
      const s = new Search('id')
      s.searchIndex = new UnorderedSearchIndex()
      s.addIndex('search')
      s.addDocuments(dataSource.attributes)
      return {
        name: dataSource.name,
        searchIndex: s
      }
    })
    this.initialized = true
  }

  /**
   * gets the preSearchDataSources set based off the current filter that is going to be applied to the datasets
   */
  filterDatasets (filterset) {
    this.filter = filterset || this.filter
    if (this.filter.length > 0) {
      let filteredDataSources = this.originalDataSources.filter(x => !this.filter.includes(x.name))
      this.preSearchedDataSources = filteredDataSources
      this.dataSources = []
      this.initialized = false
    } else {
      this.preSearchedDataSources = this.originalDataSources
    }
  }

  resetDatasets () {
    // this will add back the datasets
    this.preSearchedDataSources = this.originalDataSources
    this.filter = []
    this.dataSources = []
    this.initialized = false
  }

  search (term) {
    if (!this.initialized) {
      this.init()
    }
    return this.dataSources.map(dataSource => {
      return {
        name: dataSource.name,
        results: dataSource.searchIndex.search(term)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/attributePanel/services/search.js